export { default } from './SurveyConfirmation';
